import React from 'react';
import _ from 'lodash';
import {Stack, Typography} from '@mui/material';
import api from '../util/api.js';
import {useOnce, useQueryParam} from '../util/react_hooks.js';

const EmailUnsubscribe = ()=>{
    let [email] = useQueryParam('email');
    useOnce(()=>api.unsubscribeEmail(email), !!email);
    return <Stack direction="column" justifyContent="center" gap={2} margin={4}>
      <Typography variant="h3">
        הוסרת מרשימת התפוצה בהצלחה
      </Typography>
      <Typography variant="h4">{email}</Typography>
    </Stack>;
};

export default EmailUnsubscribe;
